import httpClient from "../../clients/httpClient";
import {
    AppleSetupField,
    IAppleSetupResource,
} from "../../state/types/apple-setup";

const BASE = "/api/v1/apple-setup";

export const getAppleSetup = () => {
    return httpClient.get<IAppleSetupResource>(BASE);
};

// One field per call — partial body. First real save flips not_started → in_progress.
export const patchAppleSetupField = (field: AppleSetupField, value: string) => {
    return httpClient.patch<IAppleSetupResource>(BASE, { [field]: value });
};

export const uploadAppleSetupKey = (file: File) => {
    const form = new FormData();
    form.append("key", file);
    return httpClient.post<IAppleSetupResource>(`${BASE}/key`, form, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};

export const finishAppleSetup = () => {
    return httpClient.post<IAppleSetupResource>(`${BASE}/finish`, {});
};
